import SettingsSection from '../../SettingsSection';

import { CalloutType, TextIconColor } from '~/components/core';
import { Markdown } from '~/components/Markdown';
import { useMarkdownFile } from '~/hooks';

const SetupInstructions = () => {
  const { markdown: continueSetupMarkdown } = useMarkdownFile(
    '/docs/Continue/ContinueSetup.md'
  );
  const { markdown: continueExamplesMarkdown } = useMarkdownFile(
    '/docs/Continue/ContinueExamples.md'
  );
  const { markdown: continueTroubleshootingMarkdown } = useMarkdownFile(
    '/docs/Continue/ContinueTroubleshooting.md'
  );

  return (
    <SettingsSection title="Setup Instructions">
      <div className="my-3 flex flex-col" data-testid="plugins-setup-container">
        <div
          className="bg-off-black mb-12 flex flex-col gap-4 rounded-lg bg-opacity-30 p-[30px]"
          data-testid="plugins-setup-block-container"
        >
          <Markdown># Setting up Kindo as a Provider in Continue</Markdown>
          <Markdown
            calloutType={CalloutType.SECURITY}
            textColor={TextIconColor.SECONDARY}
          >
            {continueSetupMarkdown}
          </Markdown>
        </div>
        <div
          className="mb-12 ml-4 flex flex-col gap-4"
          data-testid="plugins-examples-container"
        >
          <Markdown># Examples</Markdown>
          <Markdown styleDocsComponents textColor={TextIconColor.SECONDARY}>
            {continueExamplesMarkdown}
          </Markdown>
        </div>
        <div
          className="bg-off-black mb-12 flex flex-col gap-4 rounded-lg bg-opacity-30 p-[30px]"
          data-testid="plugins-troubleshooting-container"
        >
          <Markdown># Troubleshooting</Markdown>
          <Markdown textColor={TextIconColor.SECONDARY}>
            {continueTroubleshootingMarkdown}
          </Markdown>
        </div>
      </div>
    </SettingsSection>
  );
};

export default SetupInstructions;
